import _toConsumableArray from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Tool from './tool';
import { resolveComponent } from "vue";
var Table = {
  /**
   *
   * @param $this this对象
   * @param values cascader绑定的值
   * @param dataList 数据集合
   * @param columnsName 字段名称
   * @param changeCallback 修改事件回调
   * @param filterCallBack 校验是否有过滤数据回调
   * @returns {function(*, *): *}
   */
  buildCascaderFilter: function buildCascaderFilter(_ref) {
    var values = _ref.values,
      dataList = _ref.dataList,
      columnsName = _ref.columnsName,
      changeCallback = _ref.changeCallback,
      _ref$filterCallBack = _ref.filterCallBack,
      filterCallBack = _ref$filterCallBack === void 0 ? function () {
        return false;
      } : _ref$filterCallBack;
    return function (h, column) {
      return h(resolveComponent('Cascader'), {
        modelValue: values,
        data: Table.buildCascaderFilterList(dataList),
        transfer: true,
        style: {
          width: '100%'
        },
        onOnChange: function onOnChange(dataList, dataInfoList) {
          changeCallback && changeCallback(dataList, dataInfoList);
        }
      }, {
        default: function _default() {
          return [h('span', {
            class: ['ivu-table-filter']
          }, [h('span', {
            innerText: columnsName
          }), h(resolveComponent('Icon'), {
            type: 'ios-funnel',
            class: {
              'on': filterCallBack && filterCallBack()
            }
          })])];
        }
      });
    };
  },
  buildCascaderFilterList: function buildCascaderFilterList() {
    var dataList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (Tool.isNull(dataList)) {
      return [];
    }
    var list = dataList.map(function (item) {
      return {
        label: item.label,
        value: item.value,
        children: Table.buildCascaderFilterList(item.children)
      };
    });
    return [{
      label: '全部',
      value: null,
      children: []
    }].concat(_toConsumableArray(list));
  },
  /**
   * 获取table column某个列的下标
   * @param columns
   * @param key
   * @returns {*}
   */
  getColumnsIndex: function getColumnsIndex(columns, key) {
    return columns.findIndex(function (item) {
      return item.key == key || item.slot == key;
    });
  },
  filterColumns: function filterColumns(columns, list, key) {
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
      return true;
    };
    var have = Tool.isNotNull(list.filter(function (item) {
      return Tool.isNotNull(item[key]);
    }));
    if (!have && callback()) {
      var index = Table.getColumnsIndex(columns, key);
      if (index != -1) {
        columns.splice(index, 1);
      }
    }
  },
  initTableFilterValue: function initTableFilterValue(columns, key, value) {
    if (Tool.isNotNull(value)) {
      var index = Table.getColumnsIndex(columns, key);
      if (index != -1) {
        if (value instanceof Array) {
          columns[index].filteredValue = _toConsumableArray(value);
        } else {
          columns[index].filteredValue = [value];
        }
      }
    }
  },
  resetFilter: function resetFilter(table, columns, key) {
    var index = Table.getColumnsIndex(columns, key);
    if (index != -1) {
      table.handleFilterReset(index);
    }
  }
};
export default Table;